// extracted by mini-css-extract-plugin
export const container = "instructions-module--container--156hx";